import React, { useMemo } from "react";
import { Group } from "react-konva";
import { IMondayTaskController, MondayItemColumn } from "../../controller";
import { MondayTaskSection } from "shared/datamodel/monday-task";
import { StatusColumn } from "./status-column";
import { DateColumn } from "./date-column";
import { COLUMN_WIDTH, PADDING } from "../../consts";
import { useDeepEqualMemo } from "frontend/hooks/use-deep-memoize";
import useObservableController from "elements/hooks/use-observable-controller";
import { GenericColumn } from "./generic-column";
import { AvatarColumn } from "./avatar-column";
interface PinnedColumnsProps {
  controller: IMondayTaskController;
  contentWidth: number;
}

const COLUMN_GAP = 7;

export const PinnedColumns = React.memo(({ controller, contentWidth }: PinnedColumnsProps) => {
  useObservableController(controller, [
    "pinned-columns-changed",
    "hidden-columns-changed",
    "item-changed",
    "board-columns-changed",
    "size-changed",
  ]);

  // IDK why 4 works here, but it does. Design stuff
  const MAGIC_DESIGN_NUMBER = 4;
  const y = controller.getSectionY(MondayTaskSection.PINNED_COLUMNS) - PADDING + MAGIC_DESIGN_NUMBER;

  const columns = controller.pinnedColumns();
  const memoizedColumns = useDeepEqualMemo(columns);
  const avatarColumn = memoizedColumns.find((col) => col.type === "people");
  const allOtherColumns = memoizedColumns.filter((col) => col.id !== avatarColumn?.id);

  return (
    <Group y={y}>
      <ValueColumns columns={allOtherColumns} controller={controller} />
      {avatarColumn && <AvatarColumn column={avatarColumn} contentWidth={contentWidth} />}
    </Group>
  );
});

PinnedColumns.displayName = "PinnedColumns";

function ValueColumns({ columns, controller }: { columns: MondayItemColumn[]; controller: IMondayTaskController }) {
  const columnPositions = useMemo(() => {
    let currentX = 0;
    return columns.map((_) => {
      const columnX = currentX;
      currentX += COLUMN_WIDTH + COLUMN_GAP;
      return { columnX };
    });
  }, [columns]);

  return (
    <>
      {columns.map((column, index) => {
        const { columnX } = columnPositions[index];

        if (column.type === "status") {
          return <StatusColumn key={column.id} column={column} x={columnX} controller={controller} />;
        } else if (column.type === "date") {
          return <DateColumn key={column.id} column={column} x={columnX} controller={controller} />;
        } else {
          return <GenericColumn key={column.id} column={column} x={columnX} />;
        }
      })}
    </>
  );
}
